<div class="cpb5" fxLayout="row wrap">
    <div fxFlex="100" fxFlex.lt-md="100">
      <app-buyer-announcement-filtre
        (searchoptions)="onSearch($event)"
      ></app-buyer-announcement-filtre> 
    </div>
    <div fxFlex="100" fxFlex.lt-md="100">
      <mat-card class="table-card" appCard>
       <!--   <mat-card-header fxLayout="row wrap" fxLayoutAlign="space-between center">
          <mat-card-title translate>Cmis-list</mat-card-title>
          <div>
           <ng-container *ngxPermissionsOnly="PERMISSIONS.MOVEMENT_TYPE.CREATE">
              <button color="primary" mat-icon-button routerLink="create">
                <mat-icon>add_outline</mat-icon>
              </button>
            </ng-container> 
          </div>
        </mat-card-header> -->
        <mat-card-content>
         
             <app-buyer-announcement-table (sort)="onSort($event)"
  
             [list]="data">      
             </app-buyer-announcement-table>
            
         
             <app-paginator
             (paginate)="onPaginate($event)"
             [total]="totalCount"
           ></app-paginator>
        </mat-card-content>
      </mat-card>
    </div>
  </div>
  